const IoTData = [
  {
    core: [
      {
        id: "1",
        name: "Kerala IoT Challenge Level 1",
        karma: "400",
        description:
          "Foxlab Makerspace, in association with GTech - Group of Technology Companies in Kerala, is launching our prestigious program, “Kerala IoT Challenge 2021”, with a vision to mould 100 IoT experts in Kerala, hosted on the μLearn platform. Kerala IoT Challenge is a program designed with 4 levels followed by a hackathon to identify and train quality industry leaders in the IoT domain, while any novice learner can start with layer 1, and others can enter laterally to the desired layer after an evaluation.",
        link: "https://mulearn.atfg.gtechindia.org/page/iotlevel1",
        inner_description:
          "After course completion, post the certificate in the #internet-of-things-iot-and-robotics channel of the µLearn Discord server with the hashtag #kerala-iot-challenge to avail karma points.",
        example:
          "#kerala-iot-challenge Hey! I’ve completed Kerala IoT Challenge Level 1. Here is my course certificate. ",
      },
      {
        id: "2",
        name: "Introduction to IOT - Cisco Networking Acdaemy",
        karma: "800",
        description:
          "Discover how the Internet of Things is enabling digital transformations across a variety of industries and can expand career opportunities in the future.",
        link: "https://skillsforall.com/course/introduction-iot",
        inner_description:
          "After course completion, post the certificate in the #internet-of-things-iot-and-robotics channel of the µLearn Discord server with the hashtag ##cl-iot-cisco to avail karma points.",
        example:
          "#cl-iot-cisco Hey! I’ve completed Introduction to IOT - Cisco Networking Acdemy. Here is my course badge. ",
      },
      // {
      //   id: "2",
      //   name: "Kerala IoT Challenge Level 2",
      //   karma: "400",
      //   description:
      //     "The second level of Kerala IoT Challenge aims to expertise students in IoT.",
      //   link: "https://mulearn.atfg.gtechindia.org/page/iotlevel2",
      //   inner_description:
      //     "After course completion, post the certificate in the #internet-of-things channel of the µLearn Discord server with the hashtag #kerala-iot-challenge to avail karma points.",
      //   example:
      //     " #kerala-iot-challenge Hey! I’ve completed Kerala IoT Challenge Level 2. Here is my course certificate.",
      // },
    ],
    enablement: [
      {
        id: "1",
        name: "IoT 101",
        karma: "50",
        description:
          "It’s possible that you are listening more and more to the term Internet of Things (IoT). But, what exactly is IoT, and most importantly, what changes will the adoption of IoT bring to households, commerce and industry?. In this course you’ll get a basic understanding on what’s IoT? ",
        link: "https://mulearn.atfg.gtechindia.org/page/iot101",
        inner_description:
          "After course completion, share the certificate in #internet-of-things channel with hashtag #ge-iot-101",
        example:
          "#ge-iot-101 Hey I’ve completed IoT 101 course. Here’s my certificate. ",
      },
      {
        id: "2",
        name: "What’s IoT?",
        karma: "50",
        description:
          "IoT is known for monitoring and controlling devices remotely, and this course aims at familiarizing you with the Internet of Things. The course starts by introducing IoT. Enroll in this IoT free course and gain a free certificate.",
        link: "https://www.mygreatlearning.com/academy/learn-for-free/courses/what-is-iot",
        inner_description:
          "After course completion, share the certificate in #internet-of-things channel with hashtag #ge-what-is-iot",
        example:
          "#ge-what-is-iot Hey I’ve completed What is IoT course. Here’s my course certificate.",
      },
    ],
  },
];

export default IoTData;
